import React from 'react';
import { ThemeProvider } from "styled-components";
import {
  createMuiTheme,
  responsiveFontSizes,
  StylesProvider,
  ThemeProvider as MuiThemeProvider
} from "@material-ui/core";
import CssBaseline from '@material-ui/core/CssBaseline';

const theme = createMuiTheme({
  typography: {
    fontFamily: `'Open Sans', sans-serif`,
    fontSize: 14,
    htmlFontSize: 14
  },
  palette: {
    primary: {
      main: '#083F8B'
    },
    secondary: {
      main: '#FECC69'
    },
    background: {
      default: "white"
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        html: {
          maxWidth: '100vw',
          overflowX: 'hidden',
          color: '#515465'
        }
      }
    },
    MuiButton: {
      root: {
        borderRadius: '5px',
        minHeight: '58px',
        fontSize: '1.2rem'
      }
    },
    MuiInputBase: {
      root: {
        borderRadius: '5px',
        minHeight: '58px'
      }
    },
    MuiChip: {
      root: {
        borderRadius: '5px'
      }
    },
    MuiBackdrop: {
      root: {
        color: 'white',
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        zIndex: 1000
      }
    },
    MuiAccordionDetails: {
      root: {
        padding: '0 1rem'
      }
    },
    MuiAccordionSummary: {
      content: {
        margin: 0
      },
      root: {
        "&$expanded": {
          "margin": 0
        }
      }
    },
    MuiTooltip: {
      tooltip: {
        fontSize: '1rem'
      }
    },
    MuiDialog: {
      paper: {
        zIndex: 1400
      }
    },
    MuiLinearProgress: {
      root: {
        height: 8,
        borderRadius: 8
      },
      bar: {
        borderRadius: 8
      }
    }
  },
  props: {
    MuiButton: {
      disableElevation: true
    }
  }
});

const responsiveTheme = responsiveFontSizes(theme);

export default ({ children }) => (
  <StylesProvider injectFirst={true}>
    <MuiThemeProvider theme={responsiveTheme}>
      <ThemeProvider theme={responsiveTheme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </MuiThemeProvider>
  </StylesProvider>
);
